import { useNavigate } from "react-router-dom";

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const res = await fetch("http://217.13.111.96:5000/logout", {
        method: "POST",
        credentials: "include", // <- fontos!
      });

      if (res.ok) {
        localStorage.removeItem("token");
        window.location.href = "/login";
      } else {
        alert("Hiba a kijelentkezéskor");
      }
    } catch (err) {
      console.error("Logout hiba:", err);
      alert("Nem sikerült csatlakozni a szerverhez");
    }
  };

  return <button onClick={handleLogout}>Kijelentkezés</button>;
};

export default LogoutButton;
